<div class="container-fluid cards-container">
    @let kpi = kpis()[0];
    <div class="row g-3">
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.totalLvNetworkLength.title"
                [body]="{
                    value: kpi.totalLvNetworkLength,
                    suffix: texts.totalLvNetworkLength.suffix,
                    precision: texts.totalLvNetworkLength.precision,
                }"
                [descriptionTitle]="texts.totalLvNetworkLength.descriptionTitle"
                [descriptionContent]="texts.totalLvNetworkLength.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [badge]="{
                    value: kpi.totalLvNetworkLengthEvolution,
                    suffix: texts.totalLvNetworkLength.badgeSuffix,
                    precision: texts.totalLvNetworkLength.badgePrecision,
                    style: kpi.totalLvNetworkLengthEvolution! > 0 ? 'success' : 'danger',
                }"
                [error]="checkKpiErrors(kpi, 'totalLvNetworkLength')"
                cardClass="h-100"></kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.lvBurialRate.title"
                [body]="{
                    value: kpi.lvBurialRate,
                    suffix: texts.lvBurialRate.suffix,
                    precision: texts.lvBurialRate.precision,
                }"
                [descriptionTitle]="texts.lvBurialRate.descriptionTitle"
                [descriptionContent]="texts.lvBurialRate.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [badge]="{
                    value: kpi.lvBurialRateEvolution,
                    suffix: texts.lvBurialRate.badgeSuffix,
                    precision: texts.lvBurialRate.badgePrecision,
                    style: kpi.lvBurialRateEvolution! > 0 ? 'success' : 'danger',
                }"
                [error]="checkKpiErrors(kpi, 'lvBurialRate')"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.lvFeedersCount.title"
                [body]="{ value: kpi.lvFeedersCount, precision: texts.lvFeedersCount.precision }"
                [isLoading]="!kpi.organizationId"
                [badge]="{
                    value: kpi.lvFeedersCountEvolution,
                    suffix: texts.lvFeedersCount.badgeSuffix,
                    precision: texts.lvFeedersCount.badgePrecision,
                    style: kpi.lvFeedersCountEvolution! > 0 ? 'success' : 'danger',
                }"
                [error]="checkKpiErrors(kpi, 'lvFeedersCount')"
                cardClass="h-100">
            </kpi-card>
        </div>

        <chart-card
            id="lvNetworkTypeProportionChart"
            [title]="texts.lvNetworkTypeProportionChart.title"
            [error]="lengthChartError"
            [isLoading]="!lengthChartData()[0].organizationId"
            [series]="lengthChartSeries"
            [dataLabels]="lengthDataLabels"
            [stacked]="true"
            [descriptionContent]="texts.lvNetworkTypeProportionChart.descriptionContent"
            [descriptionTitle]="texts.lvNetworkTypeProportionChart.descriptionTitle"
            [xaxisCategories]="lengthXaxisCategories"
            [yaxis]="lengthYaxis"
            [precision]="texts.lvNetworkTypeProportionChart.precision"
            [xaxisTitle]="texts.lvNetworkTypeProportionChart.xaxisTitle"
            [customTooltip]="lvNetworkTypeProportionCustomTooltip"
            class="h-100"></chart-card>

        <chart-card
            id="lvUndergroundRateChart"
            [title]="texts.lvUndergroundRateChart.title"
            [descriptionTitle]="texts.lvUndergroundRateChart.descriptionTitle"
            [descriptionContent]="texts.lvUndergroundRateChart.descriptionContent"
            [error]="rateChartError"
            [isLoading]="!chartDataDep()[0].organizationId"
            [series]="rateChartSeries"
            type="scatter"
            [dataLabels]="rateDataLabels"
            [xaxisTickAmount]="
                texts.lvUndergroundRateChart.xmax / texts.lvUndergroundRateChart.tickStep - 1
            "
            [yaxis]="rateYaxis"
            [precision]="texts.lvUndergroundRateChart.precision"
            [xmin]="texts.lvUndergroundRateChart.xmin"
            [xmax]="texts.lvUndergroundRateChart.xmax"
            [xaxisTitle]="texts.lvUndergroundRateChart.xaxisTitle"
            [customTooltip]="lvUndergroundingRateCustomTooltip"
            class="h-100">
        </chart-card>
    </div>

    <geo-map-card
        [title]="texts.lvUndergroundingRateMap.title"
        [descriptionContent]="texts.lvUndergroundingRateMap.descriptionContent"
        [descriptionTitle]="texts.lvUndergroundingRateMap.descriptionTitle"
        [geometries]="geometries()"
        [isLoading]="!geometries()[0].organizationId"
        [error]="!!geometries()[0].error"
        [getStyle]="getMapStyle"
        [legendConfig]="legendConfig"
        [mapId]="'lvUndergroundingRateMap'"
        [getTooltip]="getTooltip"></geo-map-card>
</div>
